import React from 'react';

import PulseMonitor from './PulseMonitor.js';
import { plethAmplitude } from './pulseModel.js';

const COLOR = [73, 176, 203];
const sample = (seconds) => 130 - 85 * plethAmplitude(seconds);
// SpO2 is an independent measurement, not inferred from single-channel PPG height.
const readout = () => 98;

const PlethSketch = () => (
  <PulseMonitor
    label="PLETH"
    className="pleth"
    color={COLOR}
    sample={sample}
    readout={readout}
    initialValue={98}
    valueId="pleth-value"
    unit="SpO₂"
  />
);

export default PlethSketch;
